import {AddItemResponseStatus_Success_Section_CouponBasketItemsPriceDecreased} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import {useTranslation} from '@aboutyou/i18n';
import {useBasketRoute} from '@aboutyou/router';
import {
  Button,
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  ProductImage,
  Text,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

const DATA_TESTID = 'a2bSuccessSectionMultipleItemsPriceDecreased';
const MAX_PRODUCTS_SHOWN = 4;

export const MultipleItemsPriceDecreased: React.FC<{
  className?: string;
  couponBasketItemsPriceDecreased: AddItemResponseStatus_Success_Section_CouponBasketItemsPriceDecreased;
}> = ({className, couponBasketItemsPriceDecreased}) => {
  const {t} = useTranslation();
  const basketPageRoute = useBasketRoute();

  return (
    <Wrapper data-testid={DATA_TESTID} className={className}>
      <Headline data-testid={`${DATA_TESTID}-Headline`} size="px16">
        {couponBasketItemsPriceDecreased.headline}
      </Headline>
      <Content>
        <Products>
          {couponBasketItemsPriceDecreased.deliveryItems
            .slice(0, MAX_PRODUCTS_SHOWN)
            .map((item, index) => {
              const image = item.product.primaryBustImage;

              return (
                <ProductImageWrapper
                  data-testid={`${DATA_TESTID}-Product`}
                  key={index}
                >
                  <ProductImage
                    alt={image.description}
                    columns={3}
                    src={image.src}
                    padded={image.isEnclosed}
                    increasePadding
                  />
                </ProductImageWrapper>
              );
            })}
        </Products>
        {couponBasketItemsPriceDecreased.deliveryItems.length >
          MAX_PRODUCTS_SHOWN && (
          <MoreButton
            data-testid={`${DATA_TESTID}-MoreButton`}
            variant="secondary"
            href={basketPageRoute}
            aria-label={undefined}
          >
            {t('+{count} more', {
              count:
                couponBasketItemsPriceDecreased.deliveryItems.length -
                MAX_PRODUCTS_SHOWN,
            })}
            <Icon asset={GenericIconName.ArrowLongRight} size="XSS" />
          </MoreButton>
        )}
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
`;

const Headline = styled(Text)`
  line-height: 1.5;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid;
  padding: 8px;
  border: 1px solid ${COLORS.Grey3};
  border-radius: 4px;
`;

const Products = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const ProductImageWrapper = styled.div`
  width: 54px;
`;

const MoreButton = styled(Button)`
  margin-left: 16px;
  margin-right: 8px;
  flex: 1;
  height: fit-content;
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.light};
  padding: 4px 8px;
`;
